import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { AppId, WhispSiteView } from '../../../model';

@Injectable({ providedIn: 'root' })
export class WhispCheckService {
  private readonly http = inject(HttpClient);

  checkNow(siteId: AppId): Promise<unknown> {
    return firstValueFrom(this.http.post(`api/site/${siteId}/whisp/check`, null));
  }

  view(siteId: AppId): Promise<WhispSiteView | null> {
    return firstValueFrom(this.http.get<WhispSiteView | null>(`api/site/${siteId}/whisp`));
  }
}
